import { render, staticRenderFns } from "./statPage.vue?vue&type=template&id=f9372d22&"
import script from "./statPage.vue?vue&type=script&lang=js&"
export * from "./statPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports